import React from "react";
import Footer from "../Comman/Footer";
import Header from "../Comman/Header";
const PrivacyPolicy = () => {
  return (

    <>
    <Header/>

    <div className="relative min-h-screen bg-gray-50 py-20 px-6 overflow-hidden">

      {/* Soft Background Glow */}
      <div className="absolute -top-40 -left-40 w-96 h-96 bg-[#a8721e]/10 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-[#a8721e]/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-4xl mx-auto">

        {/* Header */}
        <div className="text-center mt-18 mb-14">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight">
         Privacy Policy

          </h1>
          <div className="w-20 h-1 bg-[#a8721e] mx-auto mt-6 rounded-full"></div>
          <p className="mt-4 text-sm text-gray-500">
       <span className="font-bold">
        Last Updated:
        </span>  20th Feb 2026

          </p>
        </div>

        {/* Main Card */}
        <div className="bg-white border border-gray-200 rounded-3xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.15)] p-10 md:p-14 space-y-12 text-gray-700 leading-relaxed text-[16px]">

          <p>
       ZenoChain (“we,” “our,” or “us”) is a decentralized blockchain network designed to enable transparent, trustless, and autonomous on-chain interactions. This Privacy Policy explains how information is handled when you access or use the ZenoChain network, website, applications, and related services (collectively, the “Platform”).

          </p>

          {/* 1 */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
              <span className="w-2 h-8 bg-[#a8721e] rounded-sm"></span>
1. Information We Collect

            </h2>

            <h3 className="font-semibold text-gray-900 mt-6 mb-3">
           1.1 Blockchain Data

            </h3>

            <p>ZenoChain records blockchain-related data including:
</p>
            <p className="mt-3">Wallet addresses
</p>
            <p>Transaction hashes
</p>
            <p>Smart contract interactions
</p>
            <p>Block and network activity data
</p>

            <p className="mt-4">
           This information is <span className="font-bold">
            public, immutable, and stored on-chain.
            </span> 

            </p>

            <h3 className="font-semibold text-gray-900 mt-8 mb-3">
         1.2 Off-Chain Information

            </h3>

            <p>
          When interacting with ZenoChain websites or support channels, limited technical data may be collected, such as:

            </p>

            <p className="mt-3">Browser type and device information
</p>
            <p>IP address and usage analytics
</p>
            <p>Communication data submitted voluntarily
</p>

            <p className="mt-4">
          ZenoChain does <span className="font-bold">
            not collect
            </span>  private keys, seed phrases, passwords, or custodial credentials.

            </p>
          </div>

          {/* 2 */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
              <span className="w-2 h-8 bg-[#a8721e] rounded-sm"></span>
          2. How Information Is Used

            </h2>

            <p>Information is used to:

</p>

            <p className="mt-3">Operate and maintain the ZenoChain network
</p>
            <p>Improve performance, security, and reliability
</p>
            <p>Monitor network activity and prevent abuse
</p>
            <p>Communicate updates or technical notices
</p>
            <p>Comply with legal obligations where applicable
</p>
          </div>

          {/* 3 */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
              <span className="w-2 h-8 bg-[#a8721e] rounded-sm"></span>
         3. Decentralized & Public Nature

            </h2>

            <p>ZenoChain is a <span className="font-bold">
              public blockchain.
              </span> 
 {/* All on-chain data is: */}
</p>
            <p>All on-chain data is:</p>

            <p className="mt-3">Transparent</p>
            <p>Permanent</p>
            <p>Not owned, altered, or deleted by ZenoChain
</p>

            <p className="mt-4">
          Users acknowledge that blockchain data may be viewed by third parties.

            </p>
          </div>

          {/* 4 */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
              <span className="w-2 h-8 bg-[#a8721e] rounded-sm"></span>
            4. Cookies & Tracking

            </h2>

            <p>
            ZenoChain websites may use cookies or similar technologies to enhance functionality and analyze usage.

            </p>

            <p className="mt-3">
        Users may control cookie preferences through browser settings.

            </p>
          </div>

          {/* 5 */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
              <span className="w-2 h-8 bg-[#a8721e] rounded-sm"></span>
            5. Data Sharing

            </h2>

            <p>ZenoChain does not sell or rent personal data.
</p>
            <p>Information may be shared only:
</p>

            <p className="mt-3">With infrastructure or service providers supporting the network
</p>
            <p>When required by law or regulatory authorities</p>
            <p>To protect network integrity and security</p>
          </div>

          {/* 6 */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
              <span className="w-2 h-8 bg-[#a8721e] rounded-sm"></span>
           6. Data Security

            </h2>
 
            <p>Reasonable security measures are implemented to protect off-chain data.</p>
            <p className="mt-3">
             However, no system can guarantee absolute security.

            </p>
            <p>
        Users interact with ZenoChain <span className="font-bold">
           at their own risk.
          </span>


            </p>
          </div>

          {/* 7 */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
              <span className="w-2 h-8 bg-[#a8721e] rounded-sm"></span>
          7. Third-Party Services
            </h2>

            <p>
             ZenoChain may reference or link to third-party tools or services.

            </p>
            <p className="mt-3">
           ZenoChain is not responsible for third-party privacy practices.

            </p>
          </div>

          {/* 8 */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
              <span className="w-2 h-8 bg-[#a8721e] rounded-sm"></span>
       8. User Responsibility

            </h2>

            <p>Users are solely responsible for:
</p>

            <p className="mt-3">Securing their wallets and credentials
</p>
            <p>Understanding blockchain risks
</p>
            <p>Ensuring lawful usage in their jurisdiction
</p>

            <p className="mt-4">
       ZenoChain cannot recover lost assets or credentials.

            </p>
          </div>

          {/* 9 */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
              <span className="w-2 h-8 bg-[#a8721e] rounded-sm"></span>
         9. Policy Updates

            </h2>

            <p>
            This Privacy Policy may be updated periodically.

            </p>

            <p className="mt-3">
        Continued use of the Platform indicates acceptance of the revised policy.

            </p>
          </div>

          {/* 10 */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
              <span className="w-2 h-8 bg-[#a8721e] rounded-sm"></span>
           10. Contact

            </h2>

            <p>
          For privacy-related inquiries, please contact ZenoChain through official communication channels.


            </p>
          </div>

        </div>
      </div>
    </div>
    <Footer/>
        </>
  );
};

export default PrivacyPolicy;